import { render, staticRenderFns } from "./tkEdit.vue?vue&type=template&id=b6967cca&scoped=true&"
import script from "./tkEdit.vue?vue&type=script&lang=js&"
export * from "./tkEdit.vue?vue&type=script&lang=js&"
import style0 from "./tkEdit.vue?vue&type=style&index=0&id=b6967cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6967cca",
  null
  
)

export default component.exports